(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/components/board-settings.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/components/board-settings.js');

'use strict';

svs.keno.components.play.views.BoardSettings = Marionette.View.extend({
  regions: {
    levelSelectRegion: '#levelSelectRegion',
    kungKenoSelectRegion: '#kungKenoSelectRegion',
    levelIndicatorRegion: '#levelIndicatorRegion',
    winPlanRegion: '#winPlanRegion'
  },
  modelEvents: {
    'change:rowPriceMulti': 'onChangeRowPriceMulti'
  },
  collectionEvents: {
    'active:board:changed': 'activeBoardChanged'
  },
  template(data) {
    return svs.keno.components.play.templates.board_settings(data);
  },
  initialize() {
    this.collection = this.model.get('boards');
  },
  onRender() {
    const multipliedRowPrice = this.model.get('rowPrice') * this.model.get('rowPriceMulti');
    const activeBoard = this.collection.getActive();
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const levels = this.model.get('isSystem') ? rules.SYSTEM.levels : rules.levels;
    this.showChildView('levelSelectRegion', new svs.numbergames.game.views.LevelSelect({
      model: activeBoard,
      levels
    }));
    this.showChildView('kungKenoSelectRegion', new svs.numbergames.game.views.KungKenoToggle({
      model: activeBoard
    }));
    this.showChildView('levelIndicatorRegion', new svs.numbergames.game.views.LevelIndicator({
      model: activeBoard,
      multipliedRowPrice
    }));
    this.showChildView('winPlanRegion', new svs.numbergames.game.views.WinPlan({
      model: activeBoard,
      multipliedRowPrice,
      collapsedToggleWidth: this.getOption('collapsedToggleWidth')
    }));
  },
  onChangeRowPriceMulti() {
    const multipliedRowPrice = this.model.get('rowPrice') * this.model.get('rowPriceMulti');
    this.getChildView('winPlanRegion').triggerMethod('changeRowPriceMulti', multipliedRowPrice);
    this.getChildView('levelIndicatorRegion').triggerMethod('changeRowPriceMulti', multipliedRowPrice);
  },
  activeBoardChanged(board) {
    if (!board.get('level')) {
      const levelSelectView = this.getChildView('levelSelectRegion');
      if (levelSelectView && levelSelectView.model) {
        board.set({
          level: levelSelectView.model.get('level')
        });
      }
    }
    this.render();
  }
});

 })(window);